import { DecodeHtml } from '../../utils/decodeHtml'
import { retrunAssets, returnNotImage } from '../../utils/getAssets'
import Header from '../../utils/header'
import PaginatedList from '../../utils/paginatedList'

const ApelSection = ({ data }) => {
  const title = data?.topTitle
  const content = data?.contents?.markup
  const lists =
    data?.itemList !== null
      ? data?.itemList?.items?.map(item => {
          item = item?.content?.properties
          return {
            image: item?.image
              ? retrunAssets(item?.image[0]?.url)
              : returnNotImage(),
            description: item?.content?.markup
          }
        })
      : null
  return (
    <div className='flex flex-col gap-8 p-4 lg:px-12'>
      <div className='flex flex-col gap-5'>
        <Header text={title} />
        {DecodeHtml({ html: content })}
      </div>
      {lists && lists?.length > 0 && (
        <PaginatedList
          data={lists}
          renderCard={(item, index) => (
            <div
              key={index}
              className='flex flex-col gap-3 items-center justify-start'
            >
              <img
                src={item?.image}
                alt='Apel Image'
                height={400}
                className='w-full h-auto min-h-[400px] bg-gray-200 border object-cover rounded-lg'
              />
              <div className='text-sm text-gray-700'>
                {DecodeHtml({ html: item?.description })}
              </div>
            </div>
          )}
          pageSize={6}
          innerClassName='grid grid-cols-[repeat(auto-fill,minmax(20rem,1fr))] gap-5'
          className='flex flex-col gap-8'
        />
      )}
    </div>
  )
}

export default ApelSection
